import { render, staticRenderFns } from "./AccountPay.vue?vue&type=template&id=daa948c8&scoped=true"
import script from "./AccountPay.vue?vue&type=script&lang=js"
export * from "./AccountPay.vue?vue&type=script&lang=js"
import style0 from "./AccountPay.vue?vue&type=style&index=0&id=daa948c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa948c8",
  null
  
)

export default component.exports